/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const targxNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: 'heroicons_outline:home',
    type: 'basic',
    link: '/dashboard',
  },
  {
    id: 'proposal',
    title: 'Proposals',
    icon: 'heroicons_outline:currency-dollar',
    type: 'basic',
    link: '/proposal',
    modules: ['proposal'],
    badge: {
      title: 'new',
      classes: 'ml-1 px-2 bg-red-600 text-white rounded-full',
    },
  },
  {
    id: 'offers',
    title: 'Offers',
    type: 'basic',
    link: '/offers',
    icon: 'heroicons_outline:shopping-bag',
    modules: ['offers'],
    badge: {
      title: 'updated',
      classes: 'ml-1 px-2 bg-blue-600 text-white rounded-full',
    },
  },
  {
    id: 'requests',
    title: 'Request',
    type: 'basic',
    link: '/requests',
    icon: 'heroicons_outline:shopping-cart',
    modules: ['requests'],
    badge: {
      title: 'updated',
      classes: 'ml-1 px-2 bg-blue-600 text-white rounded-full',
    },
  },

  {
    id: 'fretes',
    title: 'Shipping',
    type: 'basic',
    link: '/shipping',
    icon: 'heroicons_outline:truck',
    modules: ['shipping'],
  },

  {
    id: 'crm',
    title: 'CRM',
    type: 'group',
    icon: 'heroicons_outline:user-group',
    modules: ['clients', 'suppliers'],
    children: [
      {
        id: 'crm.clients',
        title: 'Customers',
        type: 'basic',
        link: '/clients',
        modules: ['clients'],
        icon: 'heroicons_outline:users',
      },
      {
        id: 'crm.suppliers',
        title: 'Suppliers',
        type: 'basic',
        link: '/suppliers',
        modules: ['suppliers'],
        icon: 'heroicons_outline:identification',
      },
    ],
  },
  {
    id: 'divider-2',
    type: 'divider',
  },
  {
    id: 'reference-data',
    title: 'Reference Data',
    type: 'group',
    icon: 'heroicons_outline:collection',
    modules: [
      'species',
      'cargo-ports',
      'shipping-methods',
      'container-types',
      'shipping-companies',
      'incoterms',
      'payment-conditions',
      'currencies',
    ],
    children: [
      {
        id: 'reference-data.species',
        title: 'Species',
        type: 'basic',
        link: '/species',
        modules: ['species'],
        icon: 'heroicons_outline:globe',
      },
      {
        id: 'reference-data.ports',
        title: 'Cargo Ports',
        type: 'basic',
        link: '/cargo-ports',
        modules: ['cargo-ports'],
        icon: 'iconsmind:ship',
      },
      {
        id: 'reference-data.containers',
        title: 'Shipping Methods',
        type: 'basic',
        link: '/shipping-methods',
        modules: ['shipping-methods'],
        icon: 'iconsmind:box_close',
      },
      {
        id: 'reference-data.containerTypes',
        title: 'Container Types',
        type: 'basic',
        link: '/container-types',
        modules: ['container-types'],
        icon: 'heroicons_outline:cube',
      },
      {
        id: 'reference-data.companhias',
        title: 'Shipping Companies',
        type: 'basic',
        link: '/shipping-companies',
        modules: ['shipping-companies'],
        icon: 'heroicons_outline:library',
      },
      {
        id: 'reference-data.incoterms',
        title: 'Incoterms',
        type: 'basic',
        link: '/incoterms',
        modules: ['incoterms'],
        icon: 'heroicons_outline:scale',
      },
      {
        id: 'reference-data.paymentConditions',
        title: 'Payment Conditions',
        type: 'basic',
        link: '/payment-conditions',
        modules: ['payment-conditions'],
        icon: 'heroicons_outline:credit-card',
      },
      {
        id: 'reference-data.currencies',
        title: 'Currencies',
        type: 'basic',
        link: '/currencies',
        modules: ['currencies'],
        icon: 'heroicons_outline:cash',
      },
    ],
  },
  {
    id: 'administration',
    title: 'Administration',
    type: 'group',
    icon: 'heroicons_outline:shield-check',
    modules: ['settings', 'users', 'import'],
    children: [
      {
        id: 'administration.settings',
        title: 'Company Settings',
        type: 'basic',
        link: '/settings',
        modules: ['settings'],
        icon: 'heroicons_outline:cog',
      },
      {
        id: 'administration.import',
        title: 'Import',
        type: 'basic',
        link: '/import',
        modules: ['import'],
        icon: 'heroicons_outline:upload',
      },
      {
        id: 'administration.users',
        title: 'Users',
        type: 'basic',
        link: '/users',
        modules: ['users'],
        icon: 'heroicons_outline:user-circle',
      },
      {
        id: 'administration.roles',
        title: 'Roles',
        type: 'basic',
        link: '/roles',
        modules: ['settings'],
        icon: 'heroicons_outline:key',
      },
    ],
  },
];

export const defaultNavigation: FuseNavigationItem[] = targxNavigation;
export const compactNavigation: FuseNavigationItem[] = targxNavigation;
export const futuristicNavigation: FuseNavigationItem[] = targxNavigation;
export const horizontalNavigation: FuseNavigationItem[] = targxNavigation;
